import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHistory = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.13 3.635a8.4 8.4 0 0 1 5.92 2.445A8.372 8.372 0 0 1 6.21 17.92a.74.74 0 0 1 0-1.06.75.75 0 0 1 1.06 0c6.72 6.19 15.91-3.03 9.72-9.72a6.88 6.88 0 0 0-9.72 0L6 8.38h3a.75.75 0 0 1 0 1.5H4.25a.76.76 0 0 1-.75-.76V4.38a.75.75 0 0 1 1.5 0v2.91l1.21-1.21a8.4 8.4 0 0 1 5.92-2.445m-.658 4.338A.76.76 0 0 1 12 7.75a.76.76 0 0 1 .72.75v3.22L15 14a.75.75 0 0 1-.47 1.22A.74.74 0 0 1 14 15l-2.53-2.47a.75.75 0 0 1-.22-.53V8.5a.76.76 0 0 1 .223-.527"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHistory;
